import {Head} from '@unhead/react';
import {type ReactNode} from 'react';

type HelmProps = {
  title: string;
  children?: ReactNode;
};

const Helm = ({title, children}: HelmProps) => (
  <>
    <Head titleTemplate="%s ・ Planet Insights Platform">
      <title>{title}</title>
    </Head>

    {children}
  </>
);

export default Helm;
